module.exports = __webpack_public_path__ + "teqbahn-assets/media/10.2b812ad9.jpg";